export const VO = 'vo';
export const OV = 'ov';
export const QTZ = 'qtz';
export const UND = 'und';
export const QAA = 'qaa';
export const EN = 'en';
export const ENG = 'eng';
export const MIS = 'mis';
export const QAD = 'qad';
export const AD = 'ad';
